import { render, staticRenderFns } from "./SelectBookingType.vue?vue&type=template&id=0ab4b9f6&scoped=true&"
import script from "./SelectBookingType.vue?vue&type=script&lang=js&"
export * from "./SelectBookingType.vue?vue&type=script&lang=js&"
import style0 from "./SelectBookingType.vue?vue&type=style&index=0&id=0ab4b9f6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ab4b9f6",
  null
  
)

export default component.exports